// extracted by mini-css-extract-plugin
export default {"container":"Truckviewer_container__RzQUA","overlay":"Truckviewer_overlay__8j8R9","actions":"Truckviewer_actions__qovrN"};